import script from "./public-cookies.vue?vue&type=script&setup=true&lang=js"
export * from "./public-cookies.vue?vue&type=script&setup=true&lang=js"

import "./public-cookies.vue?vue&type=style&index=0&id=23d9f838&lang=css"

const __exports__ = script;

export default __exports__